import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import useAdd from "../../../../../api/useAdd";

const ChangePasswordDialog = ({ open, onClose, userId, token }) => {
  const { t } = useTranslation();

  const [passwords, setPasswords] = useState({
    newPassword1: "",
    newPassword2: "",
  });
  const [error, setError] = useState("");

  const { handleAdd, loading } = useAdd(
    `users/${userId}/change-password`,
    token,
    t("hr.passwordUpdatedSuccessfully"),
    t("hr.passwordChangeError")
  );

  // Handle input changes for both password fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswords((prev) => ({ ...prev, [name]: value }));
  };

  // Validate passwords and call `handleAdd`
  const handleSave = () => {
    if (passwords.newPassword1 !== passwords.newPassword2) {
      setError(t("hr.passwordsDoNotMatch"));
      return;
    }
    setError("");

    handleAdd({ password: passwords.newPassword1 });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("hr.changePassword")}</DialogTitle>
      <DialogContent>
        <TextField
          label={t("hr.newPassword")}
          name="newPassword1"
          type="password"
          fullWidth
          margin="dense"
          value={passwords.newPassword1}
          onChange={handleInputChange}
        />
        <TextField
          label={t("hr.confirmNewPassword")}
          name="newPassword2"
          type="password"
          fullWidth
          margin="dense"
          value={passwords.newPassword2}
          onChange={handleInputChange}
        />
        {error && (
          <Typography color="error" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t("hr.cancel")}
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {t("hr.savePassword")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordDialog;
